import React, { useCallback, useContext, useState } from 'react';
import { Button, Form, Tab } from 'semantic-ui-react';
import Datepicker from '../../Shared/Datepicker';
import { useForm } from '../../../Hooks/useForm';
import { OperationsContext } from '../OperationsContext';

const ClaimSummaryTab = () => {
	const {
		renewal,
		renewalClient,
		getClaimSummaryReport
	} = useContext( OperationsContext );

	const { formData, updateField } = useForm( {
		start: new Date( renewal?.start ),
		end: new Date( renewal?.end ),
		customerIds: [ renewalClient?.customerID ]
	} );

	const [ loading, setLoading ] = useState( false );

	const handleStartDateChange = useCallback( value => {
		updateField( { target: { name: 'start', value } } );
	}, [ updateField ] );

	const handleEndDateChange = useCallback( value => {
		updateField( { target: { name: 'end', value } } );
	}, [ updateField ] );

	const handleGenerateReport = useCallback( async () => {
		setLoading( true );

		const { url } = await getClaimSummaryReport( formData );

		window.open( url );

		setLoading( false );
	}, [
		formData,
		getClaimSummaryReport
	] );

	return (
		<Tab.Pane as="div">
			<Form>
				<Form.Group style={{ alignItems: 'flex-end' }}>
					<Datepicker
						label="Start Date"
						name="start"
						selected={ formData.start }
						onChange={ handleStartDateChange }
					/>
					<Datepicker
						label="End Date"
						name="end"
						selected={ formData.end }
						onChange={ handleEndDateChange }
					/>
					<Button
						primary
						onClick={ handleGenerateReport }
						loading={ loading }
					>
            Generate Report
					</Button>
				</Form.Group>
			</Form>
		</Tab.Pane>
	);
};

export default ClaimSummaryTab;
